/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  // Add custom code below this line

  document.addEventListener("DOMContentLoaded", function() {
    
    /*
    Codigo que esconde dinamicamente los sections de las paginas collection que no tengan contenido
    
    Revisamos que el body tiene la clase que contienen las paginas de collection
    para que este codigo solo tenga efecto en estas paginas
    */ 
    if(document.body.classList.contains('template-collection')){
      //Doble revision atraves de el handle
      let pathParts = window.location.pathname.split('/');
      let collectionIndex = pathParts.indexOf('collections');
      let collectionHandle = collectionIndex !== -1 ? pathParts[collectionIndex + 1] : null;

      //si la pagina es de collection
      if(collectionHandle != null){
        //seleccionamos todas las sections
        let sections = document.querySelectorAll('section');

        //Quitamos las 2 primeras porque son de productos 
        sections = Array.from(sections).slice(2);

        //Quitamos la ultima porque es el prefooter
        sections.pop();

        //Por cada section revisamos los blocks
        sections.forEach(section => {
          let blocks = section.querySelectorAll('.hero__content');
          let hasContent = false;

          /*
          Revisamo el contenido de el block sin tener en cuenta los botones,
          en caso de que tenga contenido, ponemos en true la variable.
          */
          blocks.forEach((block, blockIndex) => {
            let textContent = block.innerText.trim();
            
            Array.from(block.querySelectorAll('.btn')).forEach(button => {
              textContent = textContent.replace(button.innerText.trim(), '').trim();
            });
            
            if (textContent !== "") {
                hasContent = true;
            }
          });

          //Si no tiene contenido escondemos la section
          if (!hasContent) {
              section.style.display = 'none';
          }
        });
      }
    }
    
  });


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
